<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover" :href="route('influencers')">Influencers</inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span> Erschaffen
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.first_name" :error="form.errors.first_name" class="pr-6 pb-8 w-full lg:w-full" label="Name" />
          <text-input v-model="form.last_name" :error="form.errors.last_name" class="pr-6 pb-8 w-full lg:w-full" label="Nachname" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-full" label="Email-Adresse" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-full" label="Telefonnummer" />
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-full" label="Adresse" />
          <text-input v-model="form.zip_code" :error="form.errors.zip_code" class="pr-6 pb-8 w-full lg:w-full" label="PLZ" />
          <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-8 w-full lg:w-full" label="Ort" />
          <text-input v-model="form.country" :error="form.errors.country" class="pr-6 pb-8 w-full lg:w-full" label="Land" />
          <quill-editor
            ref="myQuillEditor"
            v-model="form.note"
            :error="form.errors.note"
            class="pr-6 pb-8 mb-8 w-full lg:w-full"
            label="Inhalt"
          />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-green" type="submit">Erschaffen</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  metaInfo: { title: 'Influencer Erschaffen' },
  components: {
    quillEditor,
    LoadingButton,
    TextInput,
  },
  layout: Layout,
  props: {
    tinyMceApiKey: String,
  },
  remember: 'form',
  data() {
    return {
      editor: null,
      form: this.$inertia.form({
        'first_name': null,
        'last_name': null,
        'email': null,
        'phone': null,
        'address': null,
        'zip_code': null,
        'city': null,
        'country': null,
        'note': null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('influencers.store').url())
    },
  },
}
</script>

